<template>
  <generic-modal :title="$t('drive')" :buttons="buttons" ref="generic_modal">
    <form>
      <div class="field">
        <label class="label">{{ $t("name") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.name" />
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p>{{ error }}</p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "DriveModal",
  components: { GenericModal },
  data() {
    return {
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: { settings: {} },
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(drive_uuid) {
      let v = this;
      v.set_initial_state();

      if (drive_uuid) {
        // v.uuid = product_uuid;
        get("/drive", { uuid: drive_uuid })
          .then((drive) => {
            v.meta = drive;
            v.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/drive", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/drive", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
